import { IconButton } from "@material-ui/core";
import i18next from "../../../assets/i18n/i18n";
import React from "react";
import "../buttons.scss";
import { itsMeUrl } from "../../../utils/urlProvider";

const ButtonMoreInfo = (): React.ReactElement => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        window.location.href = itsMeUrl;
    };

    return (
        <IconButton id="BtnMoreInfo" className="btn secondary-btn" onClick={handleClick}>
            <p className="btn-label more-info-btn-label">{i18next.t("Buttons.MoreInfo")}</p>
            <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.09766 0.550781L0.851562 0.796875C0.675781 0.972656 0.675781 1.21875 0.851562 1.39453L7.70703 8.25L0.851562 15.1406C0.675781 15.3164 0.675781 15.5625 0.851562 15.7383L1.09766 15.9844C1.27344 16.1602 1.51953 16.1602 1.69531 15.9844L9.11328 8.56641C9.28906 8.39062 9.28906 8.14453 9.11328 7.96875L1.69531 0.550781C1.51953 0.375 1.27344 0.375 1.09766 0.550781Z"
                    fill="#00725F"
                />
            </svg>
        </IconButton>
    );
};

export default ButtonMoreInfo;
